import React from 'react'
import { Box, ThemeProvider } from '@mui/material'
import { Routes, Route } from 'react-router-dom'
import DomainSearch from './domainSearch'
import { controlRoomTheme } from './theme'

function ControlRoomApp() {
  return (
    <ThemeProvider theme={controlRoomTheme}>
      <Routes>
        <Route path='/domain-search' element={<DomainSearch />} />
      </Routes>
    </ThemeProvider>
  )
}

export default ControlRoomApp
